<template>
  <table class="table b-table table-hover table-borderless table-sm">
    <tbody>
      <tr>
        <th class="table-primary b-table-sticky-column position-relative">
          Products
        </th>
        <th
          v-for="day of stockDates"
          :key="day"
          class="table-primary b-table-sticky-column position-relative"
        >
          {{ day }}
        </th>
      </tr>
      <tr v-for="stockProduct of stockProducts" :key="stockProduct">
        <td class="table-b-table-default b-table-sticky-column">
          {{ stockProduct }}
        </td>
        <td
          v-for="day of stockDates"
          :key="day"
          class="table-b-table-default b-table-sticky-column"
        >
          {{ getStockCell(day, stockProduct).count }}
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import * as moment from "moment";
export default {
  name: "stock",
  props: ["report"],
  computed: {
    stockDates() {
      if (!this.report || !this.report.data || this.report.data.length < 1)
        return [];
      return Array.from(
        new Set(
          this.report.data.map((r) =>
            moment(r._id.createdAt).format("DD/MM/YYYY")
          )
        )
      ).sort();
    },
    stockProducts() {
      if (!this.report || !this.report.data || this.report.data.length < 1)
        return [];
      return Array.from(new Set(this.report.data.map((r) => r._id.product)));
    },
  },
  methods: {
    getStockCell(day, product) {
      let cell = this.report.data.filter(
        (r) =>
          r._id.product == product &&
          moment(r._id.createdAt).format("DD/MM/YYYY") === day
      );
      return cell && cell.length > 0 ? cell[0] : { count: 0 };
    },
    getStockRow(product) {
      let filteredCells = this.report.data.filter(
        (r) => r._id.product == product
      );
      return filteredCells.reduce((sum, r) => sum + r.count, 0);
    },
    getCSVData() {
      let csvContent = "," + this.stockDates.join(",") + ", Total\r\n";
      for (let stockProduct of this.stockProducts) {
        csvContent += `"${stockProduct.replace("#", "N")}",`;
        for (let day of this.stockDates) {
          csvContent += this.getStockCell(day, stockProduct).count + ",";
        }
        csvContent += this.getStockRow(stockProduct) + "\r\n";
      }
      return csvContent;
    },
  },
};
</script>

<style scoped></style>
